import {Component, Input, OnChanges, OnDestroy, OnInit} from "@angular/core";
import {ConditionalBehaviorSubject} from "../helpers/conditional-behavior-subject";
import {SimpleChanges} from "@angular/core/src/metadata/lifecycle_hooks"; // eslint-disable-line import/no-unresolved

@Component({
  selector: "property-item",
  templateUrl: "./property-item.template.pug",
})
export class PropertyItemComponent implements OnInit, OnDestroy, OnChanges {
  subject: ConditionalBehaviorSubject<boolean> = new ConditionalBehaviorSubject<boolean>(false);
  showIfPresent: boolean = false;

  @Input("showIf")
  showIf: any;

  dot: boolean = false;

  ngOnChanges(changes: SimpleChanges) {
    if (!this.showIfPresent && changes["showIf"]) {
      this.showIfPresent = true;
    }

    this.subject.next(!this.showIfPresent || !!this.showIf);
  }

  ngOnInit() {
    if (!this.showIfPresent) {
      this.subject.next(true);
    }
  }

  ngOnDestroy() {
    this.subject.complete();
  }
}
